export default __webpack_public_path__ + "static/media/cabinet1-after-768w.22d6b2b0.avif";